import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { handleChange, handleSubmit } from "../../Controller/CreateNotesController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import Draggable from 'react-draggable';
import SunTextEditor from "../../../Common/SunTextEditor";
function CreateSaleOrderNotes({ modalInstance, currentSaleOrderNotes, onClose, onSuccess, SaleOrderID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({
        SaleOrderID: SaleOrderID, dt_Created: '', vc_Description: ""
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentSaleOrderNotes) {

            const formattedDate = new Date(currentSaleOrderNotes.dt_Created).toISOString().split('T')[0];
            setFormData({
                ...formData,
                dt_Created: formattedDate,
                vc_Description: currentSaleOrderNotes.vc_Description
            });
        } else {
            setFormData({
                ...formData,
                SaleOrderID: SaleOrderID, dt_Created: '', vc_Description: ""
            });
        }
    }, [currentSaleOrderNotes]);

    const handleFieldChange = (event) => {
        handleChange(event, formData, setFormData);
    };

    const handleEditorChange = (content) => {
        setFormData({
            ...formData,
            vc_Description: content
        });
    };



    const handleFormSubmit = (event) => {
        event.preventDefault();

        if (currentSaleOrderNotes) {
            formData.ID = currentSaleOrderNotes.PK_SalesOrderNotes_ID;
        } else {
            formData.ID = 0;
        }
        formData.FK_SalesOrder_ID = SaleOrderID;
        handleSubmit(event, formData, setFormData, setErrors, () => {
            onSuccess();

        }, () => {
            onSuccess();

        });
    };
    const handleStart = (e, ui) => {
        e.stopPropagation();
    }

    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade customerHistoryModal show d-block" id="customerHistoryModal" tabIndex="-1" aria-labelledby="customerHistoryModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <Draggable handle=".modal-content" onStart={handleStart}
                            cancel="input, textarea, select, button, ul,li,table,a,ReactQuill,p">
                            <div className="modal-content">
                                <div className={`modal-header ${accordTheme}`}>
                                    <h5 className="modal-title" id="largeModalLabel">{currentSaleOrderNotes ? "Edit History" : "Add History"}</h5>
                                    <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                        <span aria-hidden="true">&times;</span>
                                    </button>
                                </div>
                                <div className="modal-body">
                                    <div className="row mb-3" style={{ marginRight: "10px", marginTop: "10px" }}>
                                        <table style={{ width: "100%" }}>
                                            <tbody>
                                                <tr>
                                                   <td style={{width:"13%"}}> <label htmlFor="dt_Created" style={{ float: "right" }}>Date <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td style={{width:"37%"}}>
                                                        <input type="date" className="form-control" name="dt_Created" value={formData.dt_Created} onChange={handleFieldChange} />
                                                        {errors.dt_Created && <div style={{ color: 'red' }}>{errors.dt_Created}</div>}
                                                    </td>
                                                    <td style={{width:"13%"}}></td>
                                                    <td style={{width:"37%"}}></td>

                                                </tr>

                                                <tr>
                                                   <td> <label htmlFor="vc_Description" style={{ float: "right" }}>Description <span style={{ "color": "red" }}>*</span></label></td>
                                                    <td colSpan={3}>
                                                        <SunTextEditor
                                                            value={formData.vc_Description}
                                                            onChange={(content) =>
                                                                setFormData((prev) => ({
                                                                    ...prev,
                                                                    vc_Description: content,
                                                                }))
                                                            }
                                                        />
                                                        {errors.vc_Description && <div style={{ color: 'red' }}>{errors.vc_Description}</div>}
                                                    </td>
                                                </tr>

                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                                <div className="modal-footer">
                                    <button type="submit" className="btn btn-primary">
                                        <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} />  {currentSaleOrderNotes ? " Update" : " Save"}
                                    </button>
                                    <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                        <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                    </button>
                                </div>
                            </div>
                        </Draggable>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSaleOrderNotes;
